import Wl2ButtonCell from "@isceco/widget-library2/basic-elements/List/cell/ButtonCell";

export default class ButtonCell extends Wl2ButtonCell {

  constructor(configuration) {
    super(configuration)
    this.textCallback = configuration.textCallback
    this.iconCallback = configuration.iconCallback
  }

  render(i18n, cell, row) {
    if (this.textCallback) {
      this.text = this.textCallback(row)
    }
    if (this.iconCallback) {
      this.icon = this.iconCallback(row)
    }
    return super.render(i18n, cell, row)
  }
}
